import { HandshakeStatus } from './handshake-status.interface'

/**
 * Defines handshake service types
 * @deprecated */
export enum ServiceTypes {
  MICETRIBE = 1
}
/**
 * Defines v3 of the handshake system schema
 */
export interface HandshakeSchemaV3 {
  /** Handshake status */
  status: HandshakeStatus
  /** Handshake coordinator array */
  coordinators: string[]
  /**
   * Handshake allowed interaction between personas array
   */
  interactions: string[]
  /**
   * Handshake service type
   */
  service_id: ServiceTypes
  /** Handshake version */
  version: 3
}

/**
 * Dfines v2 of the handshake system schema
 */
export interface HandshakeSchemaV2 {
  /** Handshake status */
  status: HandshakeStatus
  /**
   * Handshake coordinators array
   */
  coordinators: string[]
  /**
   * Handshake allowed interaction between personas array
   */
  interactions: string[]
  /**
   * Handshake version
   */
  version: 2
}

/**
 * Defines v1 of the handshake system schema
 */
export interface HandshakeSchemaV1 {
  /** Handshake status */
  status: HandshakeStatus
  /** Handshake coordinator email */
  coordinator: string
  /**
   * Handshake allowed interaction between personas array
   */
  interactions: string[]
  /** Handshake version */
  version: 1
}
/**
 * Defines a default empty v3 schema
 */
export const DEFAULT_HANDSHAKE_SCHEMA_V3: HandshakeSchemaV3 = {
  status: HandshakeStatus.DISABLED,
  coordinators: [],
  interactions: [],
  service_id: ServiceTypes.MICETRIBE,
  version: 3
}
/**
 * Defines a default empty v2 schema
 */
export const DEFAULT_HANDSHAKE_SCHEMA_V2: HandshakeSchemaV2 = {
  status: HandshakeStatus.DISABLED,
  coordinators: [],
  interactions: [],
  version: 2
}
/**
 * Defines a default empty v1 schema
 */
export const DEFAULT_HANDSHAKE_SCHEMA_V1: HandshakeSchemaV1 = {
  status: HandshakeStatus.DISABLED,
  coordinator: '',
  interactions: [],
  version: 1
}
